import { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { Icon } from '../primitives/Icon/Icon'
import { Text } from '../primitives/Text/Text'
import { Button } from '../primitives/Button/Button'
import { getMetadata } from 'src/redux-api-bridge/metadata/selectors'
import { MetadataState } from 'src/redux-api-bridge/metadata/reducer'
import { SkipDeliverySectionProps } from './SkipDeliverySection.types'
import { useUnskip } from 'src/hooks/useUnskip'
import {
  skipDeliveryMockData,
  createSkipDeliverySubtitle
} from './SkipDeliverySection.utils'
import './SkipDeliverySection.scss'

export const SkipDeliverySection: FunctionComponent<SkipDeliverySectionProps> = ({
  deliveryDate,
  setRefetchDate
}) => {
  const metadata: MetadataState = useSelector(getMetadata)
  const mockData = skipDeliveryMockData as any

  const dynamicSubtitle =
    metadata.cutoff && metadata.displayDate
      ? createSkipDeliverySubtitle(metadata.cutoff, metadata.displayDate)
      : mockData.subtitle.attributes.value

  const subtitleComponent = {
    ...mockData.subtitle,
    attributes: {
      ...mockData.subtitle.attributes,
      value: dynamicSubtitle
    }
  }

  const { unskipIfRequired } = useUnskip(
    deliveryDate || metadata.date || undefined,
    {
      page_name: 'Orders - Manage your order'
    }
  )

  const handleUnskip = async () => {
    try {
      await unskipIfRequired()
      if (deliveryDate && setRefetchDate) {
        setRefetchDate(deliveryDate)
      }
    } catch (error) {
      // Error handling - could add logging, toast notifications, etc.
      console.error('Error unskipping delivery:', error)
    }
  }

  return (
    <div className="core-ux-skip-delivery-section">
      <div className="core-ux-skip-delivery-section__left-content">
        <Icon
          type={mockData.leftIcon.type}
          version={mockData.leftIcon.version}
          attributes={mockData.leftIcon.attributes}
          className="core-ux-skip-delivery-section__left-icon"
        />
        <div className="core-ux-skip-delivery-section__main-content">
          <Text
            type={mockData.title.type}
            version={mockData.title.version}
            attributes={mockData.title.attributes}
          />
          <Text
            type={subtitleComponent.type}
            version={subtitleComponent.version}
            attributes={subtitleComponent.attributes}
          />
        </div>
      </div>
      <Button
        type={mockData.button.type}
        version={mockData.button.version}
        attributes={mockData.button.attributes}
        onClick={handleUnskip}
        className="core-ux-skip-delivery-section__unskip-button"
      />
    </div>
  )
}
